import React from 'react';
import moment from 'moment';

const TimelineEventsList = ({ events, purposeTypes }) => {
    if (events.length === 0) {
        return (
            <div className="text-center py-5 text-muted">
                <i className="mdi mdi-timeline-text-outline" style={{ fontSize: '48px' }}></i>
                <p className="mt-2">No events found matching your filters</p>
            </div>
        );
    }

    return (
        <>
            {events.map((event) => {
                const type = purposeTypes[event.purposeOfVisit] || purposeTypes?.['General Inquiry'];
                return (
                    <div key={event.uuid} className="timeline-item">
                        <div className="timeline-icon" style={{ color: type?.color, background: type?.bg }}>
                            <i className={`mdi ${type?.icon}`}></i>
                        </div>
                        <div className="timeline-content">
                            <div className="timeline-header">
                                <span className="purpose-badge" style={{ color: type?.color, background: type?.bg }}>
                                    {type?.label}
                                </span>
                                <span className="event-date">
                                    <i className="mdi mdi-calendar-blank"></i>
                                    {moment(event.date).format('MMM D, YYYY')}
                                </span>
                            </div>
                            <div className="sales-manager">
                                <i className="mdi mdi-account-circle-outline"></i>
                                {event.salesManager}
                            </div>
                            {event.notes && (
                                <div className="event-notes">
                                    <i className="mdi mdi-text-box-outline me-1"></i>
                                    {event.notes}
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}
        </>
    );
};

export default TimelineEventsList;
